import React, { useState, useEffect } from "react";
import NoOutlineStyles from "./NoOutlineStyles";

const A11yOutline = () => {
  const [outlineActivated, setOutlineActivated] = useState(true);
  useEffect(() => {
    setOutlineActivated(false);
  }, []);
  return !outlineActivated ? /*#__PURE__*/React.createElement(NoOutlineStyles, {
    onSelfDestruct: () => setOutlineActivated(true)
  }) : null;
};

export default A11yOutline;